import styled from "styled-components";

import { useTheme } from "@hooks";
import { constants, spacing } from "@layout";
import { CSSProperties } from "react";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    form: {
      backgroundColor: theme.form.background,
      border: `1px solid ${theme.border}`,
      marginRight: spacing.m,
      marginLeft: spacing.m,
    },
    container: {
      backgroundColor: theme.body.background,
    },
  };

  return styles;
};

export const Form = styled.form`
  border-radius: ${constants.radius.card}px;
  display: flex;
  flex-direction: column;
  min-width: 280px;
  max-width: 375px;
  padding: 0px ${constants.divPadding}px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  justify-content: center;
  margin-top: 78px;

  @media (max-width: 600px) {
    padding-top: ${spacing.m}px;
    justify-content: flex-start;
    border-top: 1px solid ${({ theme }) => theme.border};
  }
`;

export const Heading = styled.div`
  margin-left: ${spacing.xxs}px;
  margin-top: ${spacing.m}px;
  margin-bottom: ${spacing.m}px;
`;
